import { type Login, type OauthToken, createOauthToken } from 'models';
import { useMutation } from 'query';
import { loginWithPassword } from '../../services';

const defaultMutateOnError = () => {
  // Do nothing
  // This mutation is used within other mutation that handle error already
};

export const useLoginMutation = () =>
  useMutation<OauthToken, Login>({
    defaultMutateOnError,
    async mutationFn({ email, password, publicCommunityId }) {
      const oauthResponse = await loginWithPassword({
        grant_type: 'password',
        join_community_id: publicCommunityId,
        password,
        provider: 'local',
        username: email,
      });

      return createOauthToken(oauthResponse.data);
    },
  });
